export const tabs = [
  {
    key: 'provenance',
    label: 'Provenance',
  },
  {
    key: 'supplyChain',
    label: 'Supply Chain',
  },
];
export const challengeCategoryOptions = {
  informationIsMissing: {
    en: 'Information is missing',
    fr: 'Information manquante',
  },
  singleSourceOfInformation: {
    en: 'Single source of information',
    fr: "Source d'information unique",
  },
  contradicted: {
    en: 'Information is contradicted by one or more sources',
    fr: "L'information est contredite par au moins une source",
  },
  documentIsMissing: {
    en: 'Documentation is missing',
    fr: 'Documentation manquante',
  },
  complianceBreach: {
    en: 'Identified compliance breach',
    fr: 'Violation de conformité identifiée',
  },
  informationNotVerified: {
    en: 'Information is not verified',
    fr: 'Information non vérifiée',
  },
};